import { ReferenceDataDto } from '../../generated/auth/models/Sasfin/Dynamics/Api/Client/Models/DTO/reference-data-dto';

export interface IRelationshipTeamState {
  list: ReferenceDataDto[];
  isLoading: boolean;
}

export const initialUIState = {
  isLoading: false,
};
